module.exports = __webpack_public_path__ + "static/media/logo-rss.b2f31e4d.svg";